<div
  #colorGradientSelect
  class="dropdown color-gradient-select">
  <button
    class="button dropdown-trigger"
    (click)="toggleIsActive()">
    <div [style.background-image]="!!selectedOption ? getGradientCSS(selectedOption) : null"></div>
    <i class="icon icon-caret_down dropdown-arrow"></i>
  </button>
  <div
    class="dropdown-menu"
    [class.is-active]="isActive"
    role="menu">
    <div class="dropdown-content">
      @for (option of gradientOptions; track option.value) {
        <div
          class="dropdown-item"
          >
          <div
            class="gradient-option"
            (click)="selectOption(option)"
          [ngStyle]="{ 'background-image': getGradientCSS(option) }"></div>
        </div>
      }
    </div>
  </div>
</div>
